import * as d3 from 'd3';

export function drawQueenAnneGrillsOculus(
  svg,
  x,
  y,
  width,
  height,
  frameWidth = 10,
  verLines = 2,            // Number of vertical grill bars
  horLines = 2,            // Number of horizontal grill bars
  lineColor = 'white',
  borderColor = 'black',
  borderWidth = 0.2,
  grillThickness = 2,
  topGridFraction = 0.33,   // Portion of height for the top grid (e.g., 1/3)
  radiusX = width / 2,
  radiusY = height / 2,
  outerShape = 'Rect'
) {
  const glassX = x;
  const glassY = y;
  const glassWidth = width;
  const glassHeight = height;

  // Calculate the height of the top grid (default to top 1/3)
  const topGridHeight = glassHeight * topGridFraction;

  // ALWAYS clip grills to the inner glass ellipse (oculus is always a circle/oval)
  const clipId = `ellipseClip_${Math.random().toString(36).substring(2, 11)}`;
  const centerX = glassX + glassWidth / 2;
  const centerY = glassY + glassHeight / 2;

  svg.append('defs')
    .append('clipPath')
    .attr('id', clipId)
    .append('ellipse')
    .attr('cx', centerX)
    .attr('cy', centerY)
    .attr('rx', radiusX)
    .attr('ry', radiusY);

  const grillContainer = svg.append('g')
    .attr('clip-path', `url(#${clipId})`);

  // --- Full height vertical bars ---
  for (let i = 1; i <= verLines; i++) {
    const gx = glassX + (glassWidth * i) / (verLines + 1);
    grillContainer.append('rect')
      .attr('x', gx - grillThickness / 2)
      .attr('y', glassY)
      .attr('width', grillThickness)
      .attr('height', glassHeight)
      .attr('fill', lineColor)
      .attr('stroke', borderColor)
      .attr('stroke-width', borderWidth);
  }

  // --- Full height horizontal bars ---
  for (let i = 1; i <= horLines; i++) {
    const gy = glassY + (glassHeight * i) / (horLines + 1);
    grillContainer.append('rect')
      .attr('x', glassX)
      .attr('y', gy - grillThickness / 2)
      .attr('width', glassWidth)
      .attr('height', grillThickness)
      .attr('fill', lineColor)
      .attr('stroke', borderColor)
      .attr('stroke-width', borderWidth);
  }

  // --- Vertical bars in top grid only ---
  for (let i = 1; i <= verLines; i++) {
    const gx = glassX + (glassWidth * i) / (verLines + 1);
    grillContainer.append('rect')
      .attr('x', gx - grillThickness / 2)
      .attr('y', glassY)
      .attr('width', grillThickness)
      .attr('height', topGridHeight)
      .attr('fill', lineColor)
      .attr('stroke', borderColor)
      .attr('stroke-width', borderWidth);
  }

  // --- Horizontal line separating top grid from lower part ---
  const topGridBottomY = glassY + topGridHeight;
  grillContainer.append('rect')
    .attr('x', glassX)
    .attr('y', topGridBottomY - grillThickness / 2)
    .attr('width', glassWidth)
    .attr('height', grillThickness)
    .attr('fill', lineColor)
    .attr('stroke', borderColor)
    .attr('stroke-width', borderWidth);
}
